module.exports = __webpack_public_path__ + "static/media/whatssap.c228af97.png";